import './StartModal.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Error from '../../../../common/Error/Error';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';

// General StartModal Component
const StartModal = ({
  category,
  movement,
  setModalOpen,
  refreshMovement,
  movementType,
  setFromPending,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const startMovement = () => {
    if (movementType == 'imports' || movementType == 'collections') {
      setLoading(true);
      GoodsIn.start(category, movement.id)
        .then(() => {
          setLoading(false);
          setFromPending(true);
          refreshMovement();
          setModalOpen(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
    if (movementType == 'exports' || movementType == 'deliveries') {
      setLoading(true);
      GoodsOut.start(category, movement.id)
        .then(() => {
          setLoading(false);
          setFromPending(true);
          refreshMovement();
          setModalOpen(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
  };

  return (
    <div className="delete_photo_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">
        Begin processing this{' '}
        {movementType == 'deliveries'
          ? 'delivery'
          : movementType.substring(0, movementType.length - 1)}
        ?
      </div>
      <div className="delete_photo_buttons">
        <button className="cancel_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={() => startMovement()}>
          OK
        </button>
      </div>
    </div>
  );
};

StartModal.propTypes = {
  category: PropTypes.string,
  movementType: PropTypes.string,
  movement: PropTypes.object,
  setModalOpen: PropTypes.func,
  refreshMovement: PropTypes.func,
  setFromPending: PropTypes.func,
};

export default StartModal;
